/* eslint-disable @typescript-eslint/unbound-method */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "setControlledInputValue", {
    enumerable: true,
    get: function() {
        return setControlledInputValue;
    }
});
const setControlledInputValue = (element, value)=>{
    var _Object_getOwnPropertyDescriptor, _Object_getOwnPropertyDescriptor1;
    const valueSetter = (_Object_getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor(element, "value")) === null || _Object_getOwnPropertyDescriptor === void 0 ? void 0 : _Object_getOwnPropertyDescriptor.set;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const prototype = Object.getPrototypeOf(element);
    const prototypeValueSetter = (_Object_getOwnPropertyDescriptor1 = Object.getOwnPropertyDescriptor(prototype, "value")) === null || _Object_getOwnPropertyDescriptor1 === void 0 ? void 0 : _Object_getOwnPropertyDescriptor1.set;
    if (valueSetter != null && valueSetter !== prototypeValueSetter) {
        prototypeValueSetter === null || prototypeValueSetter === void 0 ? void 0 : prototypeValueSetter.call(element, value);
    } else {
        valueSetter === null || valueSetter === void 0 ? void 0 : valueSetter.call(element, value);
    }
    element.dispatchEvent(new Event("input", {
        bubbles: true
    }));
};

//# sourceMappingURL=setControlledInputValue.js.map